import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

const StripeCheckoutWrapper = ({ children, clientSecret }) => {
  if (!clientSecret) return null;

  const options = {
    clientSecret,
    appearance: {
      theme: "flat",
      labels: "floating",
    },
  };

  return (
    <Elements key={clientSecret} stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

StripeCheckoutWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  clientSecret: PropTypes.string
};

export default StripeCheckoutWrapper;
